import { SvgIcon } from '@mui/material';


export const Icon = SvgIcon;
